/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Career } from '../../models/career';

export interface ApiMasterCareerGetByIdGet$Params {
  id?: string;
}

export function apiMasterCareerGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterCareerGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Career>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCareerGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Career>;
    })
  );
}

apiMasterCareerGetByIdGet.PATH = '/api/Master/Career/GetById';
